// PROVENANCE: copied from ptc-statetax 27fcfb4, src/components/moments/Confetti.tsx (the fleet primitive; spec there,
// conversions' moments in docs/accomplishment-moments.md). Deviations: none.
import { makeStyles } from '@fluentui/react-components';

// A self-contained CSS burst: no library, no canvas, no network. Under 2 s, then the pieces are
// invisible (the host unmounts them with the banner). Decorative only — aria-hidden, no pointer
// events. The HOST decides whether to render it (never under prefers-reduced-motion).

const PIECES = 18;
const COLORS = ['#0f6cbd', '#13a10e', '#ffb900', '#d13438', '#8764b8', '#00b7c3'];

const useStyles = makeStyles({
  burst: {
    position: 'absolute',
    inset: 0,
    overflow: 'visible',
    pointerEvents: 'none',
  },
  piece: {
    position: 'absolute',
    top: '0',
    width: '6px',
    height: '10px',
    borderRadius: '1px',
    opacity: 0,
    animationName: {
      '0%': { opacity: 1, transform: 'translate3d(0, 0, 0) rotate(0deg)' },
      '100%': { opacity: 0, transform: 'translate3d(var(--moment-drift), 64px, 0) rotate(540deg)' },
    },
    animationDuration: '1.6s',
    animationTimingFunction: 'cubic-bezier(0.2, 0.6, 0.4, 1)',
    animationFillMode: 'forwards',
  },
});

export default function Confetti() {
  const styles = useStyles();
  return (
    <span className={styles.burst} aria-hidden="true" data-testid="moment-confetti">
      {Array.from({ length: PIECES }, (_, i) => (
        <span
          key={i}
          className={styles.piece}
          style={{
            // Deterministic spread (no Math.random): the same burst every time, testable.
            left: `${((i * 37) % 100)}%`,
            backgroundColor: COLORS[i % COLORS.length],
            animationDelay: `${(i % 6) * 0.05}s`,
            ['--moment-drift' as string]: `${((i % 5) - 2) * 14}px`,
          }}
        />
      ))}
    </span>
  );
}
